module.exports = __webpack_public_path__ + "905c91239d804aae3a8e56d79ae593f3.svg";